var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDerivX = function SvgDerivX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "deriv-x_svg__a",
    x1: "63.183%",
    x2: "44.397%",
    y1: "-9.798%",
    y2: "101.954%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F26447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EF4852"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M0 6a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#deriv-x_svg__a)",
    d: "m6.705 10.5 4.212 5.5-6.75 5.5h6.822a4.278 4.278 0 0 0 4.167-3.316l.565-2.447a4.288 4.288 0 0 0-.82-3.624 4.278 4.278 0 0 0-3.347-1.613H6.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC2F3E",
    d: "m10.917 16-3 5.5h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.526 10.5H17.27l2.563 5.5-4.503 5.5h3.258l4.501-5.5zm4.176 0h3.295l-3.907 4.726-1.181-2.535zm-1.941 11-1.02-2.189 2.076-2.536 2.201 4.725z"
  }))));
};

export { SvgDerivX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNjMuMTgzJSIgeDI9IjQ0LjM5NyUiIHkxPSItOS43OTglIiB5Mj0iMTAxLjk1NCUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNGMjY0NDciLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNFRjQ4NTIiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMUExQTFBIiBkPSJNMCA2YTYgNiAwIDAgMSA2LTZoMjBhNiA2IDAgMCAxIDYgNnYyMGE2IDYgMCAwIDEtNiA2SDZhNiA2IDAgMCAxLTYtNlY2eiIvPjxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Im02LjcwNSAxMC41IDQuMjEyIDUuNS02Ljc1IDUuNWg2LjgyMmE0LjI3OCA0LjI3OCAwIDAgMCA0LjE2Ny0zLjMxNmwuNTY1LTIuNDQ3YTQuMjg4IDQuMjg4IDAgMCAwLS44Mi0zLjYyNCA0LjI3OCA0LjI3OCAwIDAgMC0zLjM0Ny0xLjYxM0g2LjcwNXoiLz48cGF0aCBmaWxsPSIjQ0MyRjNFIiBkPSJtMTAuOTE3IDE2LTMgNS41aC0zLjc1eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yMC41MjYgMTAuNUgxNy4yN2wyLjU2MyA1LjUtNC41MDMgNS41aDMuMjU4bDQuNTAxLTUuNXptNC4xNzYgMGgzLjI5NWwtMy45MDcgNC43MjYtMS4xODEtMi41MzV6bS0xLjk0MSAxMS0xLjAyLTIuMTg5IDIuMDc2LTIuNTM2IDIuMjAxIDQuNzI1eiIvPjwvZz48L3N2Zz4=";